import Cookies from "js-cookie"

import { IS_CA, IS_US, IS_UK } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()
  const geoCookie = Cookies.get("geo")
  const is_us = geoCookie ? geoCookie === "US" : IS_US()
  const is_ca = geoCookie ? geoCookie === "CA" : IS_CA()

  return () => {
    try {
      if (is_us || is_ca) {
        const attentiveBoxID = isMobile
          ? is_us
            ? 1335606 // US Mobile
            : 1335593 // CA Mobile
          : is_us
            ? 1335602 // US Desktop
            : 1335594 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        const lightboxID = IS_UK()
          ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
          : "acb91908-2c05-44ab-a719-47b5633fff8e" // 325686
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

export default usePopupTrigger
